import { render, staticRenderFns } from "./exchange-component.vue?vue&type=template&id=45d8cac3&scoped=true"
import script from "./exchange-component.vue?vue&type=script&lang=ts"
export * from "./exchange-component.vue?vue&type=script&lang=ts"
import style0 from "./exchange-component.vue?vue&type=style&index=0&id=45d8cac3&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d8cac3",
  null
  
)

export default component.exports